export default __webpack_public_path__ + "static/media/children-icon.6a1b81ac.svg";